export default {
  required: (value: any) => (value && value.trim()) || 'Zorunlu Alan.',
  dropdown: (value: any) => !!value.id || 'Zorunlu Alan.',
};
